import React from 'react';
import { Box, Typography, Link, IconButton, useTheme } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
// import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  const theme = useTheme();
  const logoimg = theme.palette.mode === "dark" ? "/images/SJ_SWIMMING_White_Red.png" :"/images/SJ_SWIMMING_Navy.png";

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.default, // Dynamic Background
        color: theme.palette.text.primary, // Dynamic Text
        padding: '2rem 0',
        textAlign: 'center',
        borderTop: `1px solid ${theme.palette.divider}`, // Theme-aware divider
      }}
    >
      {/* Footer Logo */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Link href="/" sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            component="img"
            src={logoimg}
            alt="SJ Logo"
            sx={{ height: 40, width: 'auto' }}
          />
        </Link>
      </Box>

      {/* Copyright Text */}
      <Typography variant="body2" sx={{ mb: 2 }}>
        SJ SWIMMING 2012
      </Typography>

      {/* Social Icons */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <IconButton 
          href="https://www.facebook.com/profile.php?id=61566915663384" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{ color: theme.palette.primary.main }}
        >
          <FacebookIcon />
        </IconButton>
        {/* <IconButton 
          href="https://www.instagram.com" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{ color: theme.palette.primary.main }}
        >
          <InstagramIcon />
        </IconButton> */}
        <IconButton 
          href="https://www.linkedin.com/company/sj-swimming/" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{ color: theme.palette.primary.main }}
        >
          <LinkedInIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Footer;
